import { Text } from "@/components/text";

import DollarIcon from "@/assets/icons/dollar-dark.svg";

export default function DescriptionSection({ description }) {
    return (
        <section
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.25rem",
            }}
        >
            <Text
                css={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "center",
                    color: "$dark",
                    overflow: "hidden",
                    textTransform: "capitalize",
                }}
            >
                <img
                    src={DollarIcon}
                    alt="Description"
                    style={{
                        width: "20px",
                        height: "20px",
                    }}
                />
                Description
            </Text>

            <Text css={{ color: "$dark" }}>
                {description}
            </Text>
        </section>
    );
}